import type { AirportBusProviderConfig } from "../config/types";
import { assertValidAirportBusProviderConfig } from "../config/validateAirportBusProviderConfig";
import { lufthansaExpressBusConfig } from "./lufthansaExpressBus";
import { viennaAirportBusConfig } from "./viennaAirportBus";

/**
 * Registered airport-bus providers.
 * Add new providers here (e.g. Lufthansa Express Bus), then register their routes explicitly.
 * Prefer `isAirportBusTransportType` for airline nav allowlists instead of hardcoding slugs.
 */
export const AIRPORT_BUS_PROVIDERS: readonly AirportBusProviderConfig[] = [
  viennaAirportBusConfig,
  lufthansaExpressBusConfig
];

AIRPORT_BUS_PROVIDERS.forEach(assertValidAirportBusProviderConfig);

const slugs = AIRPORT_BUS_PROVIDERS.map(provider => provider.slug);
if (new Set(slugs).size !== slugs.length) {
  throw new Error(`Duplicate AirportBus provider slugs: ${slugs.join(", ")}`);
}

const providersBySlug = new Map(AIRPORT_BUS_PROVIDERS.map(provider => [provider.slug, provider]));

export function getAirportBusProviderBySlug(slug: string): AirportBusProviderConfig | undefined {
  return providersBySlug.get(slug);
}

export function isAirportBusTransportType(transportType: string | null | undefined): boolean {
  if (!transportType) {
    return false;
  }
  return providersBySlug.has(transportType.toLowerCase());
}

export { lufthansaExpressBusConfig, viennaAirportBusConfig };
